module.exports = __webpack_public_path__ + "static/img/help.a89ab6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/help.png
// module id = KfKJ
// module chunks = 110